var _circle, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChangeImageOrVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("foreignObject", {
    x: -10,
    y: -10,
    width: 60,
    height: 60
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(5px)",
      clipPath: "url(#bgblur_0_41_4447_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    "data-figma-bg-blur-radius": 10,
    cx: 20,
    cy: 20,
    r: 19.5,
    fill: "white",
    fillOpacity: 0.06,
    stroke: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.1482 15.5551C13.1482 14.9167 13.4018 14.3043 13.8533 13.8528C14.3047 13.4014 14.9171 13.1477 15.5556 13.1477H21.4815C21.6288 13.1477 21.7701 13.0892 21.8743 12.985C21.9785 12.8808 22.037 12.7395 22.037 12.5922C22.037 12.4448 21.9785 12.3035 21.8743 12.1993C21.7701 12.0952 21.6288 12.0366 21.4815 12.0366H15.5556C14.6224 12.0366 13.7274 12.4073 13.0676 13.0672C12.4077 13.727 12.037 14.622 12.037 15.5551V24.444C12.037 25.3772 12.4077 26.2721 13.0676 26.932C13.7274 27.5918 14.6224 27.9625 15.5556 27.9625H24.4445C25.3776 27.9625 26.2726 27.5918 26.9324 26.932C27.5923 26.2721 27.963 25.3772 27.963 24.444V18.5181C27.963 18.3708 27.9044 18.2295 27.8003 18.1253C27.6961 18.0211 27.5548 17.9625 27.4074 17.9625C27.2601 17.9625 27.1188 18.0211 27.0146 18.1253C26.9104 18.2295 26.8519 18.3708 26.8519 18.5181V21.1181C26.8184 21.0909 26.7838 21.0652 26.7482 21.0411L24.9845 19.8655C24.4145 19.4854 23.7304 19.3146 23.0486 19.3821C22.3668 19.4497 21.7296 19.7514 21.2452 20.2359L18.7556 22.7255C18.2713 23.2098 17.6341 23.5114 16.9525 23.5789C16.2709 23.6465 15.587 23.4758 15.017 23.0959L13.1482 21.8514V15.5551ZM25.7408 12.5922C25.7408 12.4448 25.6822 12.3035 25.578 12.1993C25.4738 12.0952 25.3325 12.0366 25.1852 12.0366C25.0379 12.0366 24.8965 12.0952 24.7924 12.1993C24.6882 12.3035 24.6296 12.4448 24.6296 12.5922V14.2588H22.963C22.8156 14.2588 22.6743 14.3174 22.5701 14.4216C22.466 14.5257 22.4074 14.6671 22.4074 14.8144C22.4074 14.9617 22.466 15.103 22.5701 15.2072C22.6743 15.3114 22.8156 15.37 22.963 15.37H24.6296V17.0366C24.6296 17.184 24.6882 17.3253 24.7924 17.4295C24.8965 17.5336 25.0379 17.5922 25.1852 17.5922C25.3325 17.5922 25.4738 17.5336 25.578 17.4295C25.6822 17.3253 25.7408 17.184 25.7408 17.0366V15.37H27.4074C27.5548 15.37 27.6961 15.3114 27.8003 15.2072C27.9044 15.103 27.963 14.9617 27.963 14.8144C27.963 14.6671 27.9044 14.5257 27.8003 14.4216C27.6961 14.3174 27.5548 14.2588 27.4074 14.2588H25.7408V12.5922ZM17.4074 19.2588C17.8986 19.2588 18.3696 19.0637 18.7169 18.7164C19.0642 18.3692 19.2593 17.8981 19.2593 17.407C19.2593 16.9158 19.0642 16.4448 18.7169 16.0975C18.3696 15.7502 17.8986 15.5551 17.4074 15.5551C16.9163 15.5551 16.4453 15.7502 16.098 16.0975C15.7507 16.4448 15.5556 16.9158 15.5556 17.407C15.5556 17.8981 15.7507 18.3692 16.098 18.7164C16.4453 19.0637 16.9163 19.2588 17.4074 19.2588Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_41_4447_clip_path",
    transform: "translate(10 10)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 19.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChangeImageOrVideo);
export default __webpack_public_path__ + "static/media/ChangeImageOrVideo.a0331b4745a5429fb5b1493bb99e4b0d.svg";
export { ForwardRef as ReactComponent };